export default "__VITE_ASSET__DpYagnmP__"